// extracted by mini-css-extract-plugin
module.exports = {"title":"SideListTitle_title_2nRPW"};